import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createPort } from '../../../../common/api/clients/port.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const usePortCreate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createPort,
        onSuccess: () => queryClient.refetchQueries({ queryKey: queries.ports.pagination._def }),
    });
};
